import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column gutter-y-s2" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "mr-s1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "=", -1)
const _hoisted_5 = { class: "mr-s1" }

import TokenIcon from '@/components/token/TokenIcon.vue';
import FilledListItem from '@/components/filledList/FilledListItem.vue';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';
import { format } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { computed } from 'vue';
import { isCardanoMainnetOrTestnet } from '@/store/modules/bridge/helpers/cardano-bridge.helper';
import { useStore } from 'vuex';
import { BIG_ZERO } from '@/utils/bigNumber';
import { MIN_ADA_FOR_BRIDGE_FROM_MILKOMEDA_IN_ADA } from '@/helpers/milkomeda-wrapped-smartcontract/milkomeda-wsc-calculation';


export default /*#__PURE__*/_defineComponent({
  __name: 'BridgeInfo',
  setup(__props) {

const { bridgeForm } = useCardanoBridge();
const { state } = useStore();

const nativeFeeAmount = computed(() => {
  return bridgeForm.gasTokensFee.plus(bridgeForm.networkFee as BigNumber);
});

const receiveGasTokensFormatted = computed(() => {
  const amount = isCardanoMainnetOrTestnet(bridgeForm.fromBlockchain.name)
    ? format((nativeFeeAmount.value as BigNumber).toFixed(2, BigNumber.ROUND_DOWN))
    : MIN_ADA_FOR_BRIDGE_FROM_MILKOMEDA_IN_ADA;
  const symbol = bridgeForm.toBlockchain.nativeToken.symbol;

  return `${amount} ${symbol}`;
});

const feeFormatted = computed(() => {
  const bridgeFee = isCardanoMainnetOrTestnet(bridgeForm.fromBlockchain.name)
    ? bridgeForm.bridgeToken.blockchain1Fee
    : bridgeForm.bridgeToken.blockchain2Fee;
  const totalFee = bridgeForm.networkFee?.plus(bridgeFee) ?? BIG_ZERO;
  return `${format(totalFee.toFixed(2, BigNumber.ROUND_UP))} ${
    bridgeForm.fromBlockchain.nativeToken.symbol
  }`;
});

const blockchainIconSrc = icon => {
  return `/images/tokens/${icon}.svg`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FilledListItem, {
      caption: _ctx.$t('bridging.bridgeRate'),
      "not-filled": _unref(state).layout.isMobile
    }, {
      data: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "1 " + _toDisplayString(_unref(bridgeForm).fromToken.unwrapWETH().symbol) + " on", 1),
          _createVNode(TokenIcon, {
            "icon-src": blockchainIconSrc(_unref(bridgeForm).fromBlockchain.icon),
            size: "16"
          }, null, 8, ["icon-src"]),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, "1 " + _toDisplayString(_unref(bridgeForm).toToken.unwrapWETH().symbol) + " on", 1),
          _createVNode(TokenIcon, {
            "icon-src": blockchainIconSrc(_unref(bridgeForm).toBlockchain.icon),
            size: "16"
          }, null, 8, ["icon-src"])
        ])
      ]),
      _: 1
    }, 8, ["caption", "not-filled"]),
    _createVNode(FilledListItem, {
      caption: _ctx.$t('bridging.fee'),
      tooltip: _ctx.$t('bridging.tooltip.fee'),
      data: _unref(feeFormatted),
      "not-filled": _unref(state).layout.isMobile
    }, null, 8, ["caption", "tooltip", "data", "not-filled"]),
    _createVNode(FilledListItem, {
      caption: _ctx.$t('bridging.estimatedTimeArrival'),
      tooltip: _ctx.$t('bridging.tooltip.estimatedTimeArrival'),
      data: `5-15 ${_ctx.$t('minutes')}`,
      "not-filled": _unref(state).layout.isMobile
    }, null, 8, ["caption", "tooltip", "data", "not-filled"]),
    (_unref(bridgeForm).receiveGasTokens.gt(0))
      ? (_openBlock(), _createBlock(FilledListItem, {
          key: 0,
          caption: _ctx.$t('bridging.receivedGasTokens'),
          tooltip: _ctx.$t('bridging.tooltip.receivedGasTokens'),
          data: _unref(receiveGasTokensFormatted),
          "not-filled": _unref(state).layout.isMobile
        }, null, 8, ["caption", "tooltip", "data", "not-filled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})